import React from 'react'
import { Field } from 'react-final-form'
import { CustomSelect } from '../../../components/CustomDisabledFields'

const GerenciadoraField = props => {
  return (
    <Field
      fullWidth
      hideEmpty
      component={CustomSelect}
      options={[
        { label: 'Paraná GR', value: 'PARANAGR' },
        { label: 'Rondon', value: 'RONDON' }
      ]}
      label="Gerenciadora"
      name="gerenciadora"
      {...props}
    />
  )
}

export default GerenciadoraField
